import { Link } from "react-router-dom";

import { ApiError } from "pwapi/core/ApiError";

type EnhancedErrorMessage = {
  _meta?: { [key: string]: any };
  error_message?: string;
  error_type?: string;
};

const attributeFromErrorBody = (
  body: string | EnhancedErrorMessage,
  attribute: keyof EnhancedErrorMessage
) => {
  if (typeof body === "object" && body.hasOwnProperty(attribute))
    return body[attribute];
  return undefined;
};

const messageFromErrorBody = (body: string | EnhancedErrorMessage) => {
  if (typeof body === "string") return body;
  return attributeFromErrorBody(body, "error_message");
};

const typeFromErrorBody = (body: string | EnhancedErrorMessage) => {
  return attributeFromErrorBody(body, "error_type");
};

const ErrorToastBody = ({
  e,
  handleClose,
}: {
  e: ApiError;
  handleClose?: Function;
}) => {
  const body = e.body ? messageFromErrorBody(e.body) : undefined;
  const type = typeFromErrorBody(e.body);
  const case_id =
    type === "modmed-duplicate-order-id" ? e.body._meta?.case_id : undefined;

  // e.message is the category of request
  // will display for historical reasons for now,
  // ... but it doesn't make a whole lot of sense for users

  return (
    <div className="Toast__body">
      <p>
        <strong>{e.message}</strong>
      </p>
      {body && <p>{body}</p>}
      {case_id && (
        <p>
          Try scanning the vials from{" "}
          <strong>
            <Link
              to={`/cases/${case_id}`}
              onClick={handleClose ? () => handleClose() : undefined}
            >
              Case {case_id}
            </Link>
          </strong>
        </p>
      )}
    </div>
  );
};

export default ErrorToastBody;
